import dayjs, { extend } from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

export function registerDatePlugins() {
  extend(isToday);
  extend(isYesterday);
  extend(utc);
  extend(timezone);
}

export function buildMessageTimestampStr(
  timestamp: number,
  tz?: string,
): string {
  const dayJsTimestamp = tz ? dayjs(timestamp).tz(tz) : dayjs(timestamp);
  const meridiem = dayJsTimestamp.format('a');
  const formattedMeridiem = meridiem === 'am' ? 'a.m.' : 'p.m.';

  let date = dayJsTimestamp.format('D MMM YYYY,');
  const time = dayJsTimestamp.format('h:mm');

  if (dayJsTimestamp.isToday()) {
    date = 'Today,';
  }

  if (dayJsTimestamp.isYesterday()) {
    date = 'Yesterday,';
  }

  return `${date} ${time} ${formattedMeridiem}`;
}
